import React from 'react';

import * as breakpoint from '../../../styles/breakpoints.module.scss';
import { useLocalization } from "gatsby-theme-i18n";
import { useStaticQuery, graphql } from "gatsby"
import styled from '@emotion/styled';

import CommonSection from "../../../components/CommonSection";
import RoundButton from '../../../components/RoundButton';

const TagSection = ({ currentSection, currentTag }) => {

  const { localeKey, currentLocaleObj } = useLocalization();
  const { tags } = useStaticQuery(graphql`
    query TagSection {
      tags : allFanArtContestSubCategory(sort: {order: ASC, fields: order}) {
        edges {
          node {
            key
            title {
              ...localizedContent
            }
          }
        }
      }
    }
  `);

  return (<TagSectionWrapper>
  {tags.edges.map((item,index) => 
    <TagButton size={'large'} color={'#4E4E50'} key={`tag_${index}`} className={item.node.key === currentTag ? 'active' : ''} to={`/${currentLocaleObj.prefix}/activity/fan-art-contest/winners/${currentSection}/${item.node.key}`}>
      {item.node.title[localeKey]}
    </TagButton>
  )}
</TagSectionWrapper>);
}
 
export default TagSection;


const TagSectionWrapper = styled(CommonSection)`
  > div{
    justify-content: center;
    padding-top:48px;
    padding-bottom:0px;
    
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    >div{
      padding-top:32px;

      display:grid;
      grid-template-columns: repeat(3, 1fr);
      column-gap: 16px;
      row-gap: 16px;
    }
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    > div{
      padding-top:32px;
      
      grid-template-columns: repeat(2, 1fr);
      margin-bottom:0px;
    }
  }
`

const TagButton = styled(RoundButton)`
  height:auto;
  margin:0 16px;
  padding:12px 24px;
  font-size: 16px;
  line-height: 24px;

  &.active{
    border-color:#2C2C2E !important;
    background:#2C2C2E !important;
    span{
      color:#FCFCFF !important;
    }
  }

  &:first-of-type{
    margin-left:0;
  }

  &:last-of-type{
    margin-right:0;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    height:auto;
    padding:10px 22px;
    font-size: 16px;
    line-height: 24px;
    margin:0;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin:0;
    padding:6px 14px;
    font-size: 14px;
    line-height: 20px;
    width:auto;
  }
`
